import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { I18nStringValidationSchema } from './i18nString';
import { uuidPattern } from './regex';
const ObservationCategoryValidationSchema = z.object({
    _id: z
        .string()
        .uuid()
        .default(() => uuidv4()),
    workshopId: z.string().regex(uuidPattern, 'Not a valid id'),
    createdBy: z.string().regex(uuidPattern, 'Not a valid id'),
    description: I18nStringValidationSchema.nullable().optional(),
    created: z.date().default(() => new Date()),
    name: I18nStringValidationSchema,
    imgURL: z.string()
});
export { ObservationCategoryValidationSchema };
//# sourceMappingURL=observationCategory.js.map